import { render, staticRenderFns } from "./control-icon.vue?vue&type=template&id=6410c7bd&"
import script from "./control-icon.vue?vue&type=script&lang=js&"
export * from "./control-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports